import {
  createFileRoute,
  useParams,
  Outlet,
  useLocation,
} from "@tanstack/react-router"
import {
  LayoutWithSidebar,
  DetailSidebar,
  Separator,
  useLayoutConfig,
  Skeleton,
  formatLearningPathNames,
  getTeacherNames,
  formatLessonAvailability,
  getGroupProjectNames,
} from "toptaal-shared"
import { DetailInfoList } from "toptaal-shared"
import { Suspense } from "react"
import { useGroupSuspenseQuery } from "@/api/queries/groups/useGroupSuspenseQuery"
import ScreenWrapper from "@/components/ScreenWrapper"

export const Route = createFileRoute("/beheer/groepen/$groupId")({
  component: Parent,
})

function Parent() {
  const layoutConfig = useLayoutConfig()
  const { pathname } = useLocation()

  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId",
  })

  const base = `/beheer/groepen/${groupId}`

  const sidebarNavigationItems = [
    {
      label: "Cursisten",
      to: `${base}/students`,
    },
    {
      label: "Correspondentie",
      to: `${base}/correspondentie`,
    },
    {
      label: "Lessen",
      to: `${base}/lessen`,
    },
  ]

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        rightPanelClassName={layoutConfig.rightPanelClassName}
        disableRightPanelSuspense={layoutConfig.disableRightPanelSuspense}
        sidebar={
          <DetailSidebar
            items={sidebarNavigationItems}
            isItemActive={(route: string) => pathname.startsWith(route)}
            goBackLabel="Groepen"
            goBackRoute="/beheer/groepen"
          >
            <>
              <div className="rounded px-4 py-5 bg-white">
                <GroupTitle groupId={groupId} />

                <Separator className="my-4" />

                <GroupDetails />
              </div>
              <Separator className="my-4" />
            </>
          </DetailSidebar>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}

function GroupTitle({ groupId }: { groupId: string }) {
  const { data: group } = useGroupSuspenseQuery({
    groupId: Number(groupId),
  })

  return (
    <Suspense fallback={<Skeleton className="text-2xl font-bold mb-4 w-1/3" />}>
      <h3 className="mb-4">{group.id}</h3>
    </Suspense>
  )
}

function GroupDetails() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId",
  })

  const { data: group } = useGroupSuspenseQuery({
    groupId: Number(groupId),
  })

  return (
    <Suspense>
      <DetailInfoList
        items={[
          {
            label: "Contract",
            value: getGroupProjectNames(group.projects),
          },
          {
            label: "Leerlijn",
            value: formatLearningPathNames({
              learningPaths: group.learningPaths,
            }),
          },
          {
            label: "Maximale groepsgrootte",
            value: group.capacity,
          },
          {
            label: "Docenten",
            value: getTeacherNames(group?.teachers),
          },
          {
            label: "Beschikbaarheid",
            value: formatLessonAvailability(group.availability),
          },
        ]}
      />
    </Suspense>
  )
}
